import { type TResponse } from '@/types/global';
import { apiClient } from './apiClient';
import { type IEducation } from '@/types/educations';

export const getEducationsRequest = async () => {
  const { data } = await apiClient.get<TResponse<IEducation[]>>('educations');
  return data;
};
